import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=673cddab&"
import script from "./Location.vue?vue&type=script&lang=ts&"
export * from "./Location.vue?vue&type=script&lang=ts&"
import style0 from "./Location.vue?vue&type=style&index=0&id=673cddab&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports